module.exports = __webpack_public_path__ + "media/images/gifts/light/sug_luz_2-51fc5f40e4d669baba9c2bac726f2268.jpg";